var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
export var Notification = function (_a) {
    var title = _a.title, icon = _a.icon, message = _a.message, id = _a.id, onClick = _a.onClick, _b = _a.onRemove, onRemove = _b === void 0 ? function () { } : _b, _c = _a.type, type = _c === void 0 ? 'success' : _c, _d = _a.className, className = _d === void 0 ? '' : _d, closable = _a.closable, rest = __rest(_a, ["title", "icon", "message", "id", "onClick", "onRemove", "type", "className", "closable"]);
    return (React.createElement("div", __assign({ className: className, onClick: function (e) {
            onClick && onClick(e, onRemove);
            closable && onRemove();
        } }, rest),
        icon,
        React.createElement("div", null,
            React.createElement("div", { className: "notification-title" }, title),
            React.createElement("div", { className: "notification-content" }, message)),
        React.createElement("div", { className: "notification-close", onClick: onRemove })));
};
